import React, {Component} from "react";
import {ConfirmDialog} from "../../components/Shared/ConfirmDialog";
import {EventClient} from "../../util/eventClient";

export class ConfirmDialogEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    }
  }

  componentDidMount() {
    const self = this;
    EventClient.on("CONFIRM_DIALOG", (data) => {
      self.setState({data: {...data}})
    }, "ConfirmDialogEvent")
  }

  componentWillUnmount() {
    EventClient.off("CONFIRM_DIALOG", () => undefined, "ConfirmDialogEvent")
  }

  render() {
    if (!this.state.data || !this.state.data.message) return null;
    return <ConfirmDialog isOpen={true}
                          header={this.state.data.header}
                          children={this.state.data.message}
                          onOk={this.state.data.onOk ? () => {
                            this.state.data.onOk()
                            this.setState({data: {}});
                          } : undefined}
                          onClose={this.state.data.onClose ? () => {
                            this.state.data.onClose()
                            this.setState({data: {}});
                          } : undefined}
                          onCancel={this.state.data.onCancel ? () => {
                            this.state.data.onCancel()
                            this.setState({data: {}});
                          } : undefined}
    />
  }
}


// WEBPACK FOOTER //
// ./src/containers/Shared/ConfirmDialogEvent.js